var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_165_10",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5713 0.628418H0.628418V22.5713H22.5713V0.628418Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_165_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.628418 0.628418V17.5427C0.628418 20.3175 2.88214 22.5712 5.65699 22.5712H17.5427C20.3175 22.5712 22.5713 20.3175 22.5713 17.5427V0.628418H0.628418ZM21.657 17.5427C21.657 19.8101 19.8101 21.6569 17.5427 21.6569H5.65699C3.38956 21.6569 1.54271 19.8101 1.54271 17.5427V1.54271H21.657V17.5427Z",
    fill: "#34B689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 4.28564H5.19971V5.19993H17.9997V4.28564Z",
    fill: "#34B689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1699 16.1803L7.35275 12.3631L6.70361 13.0077L11.3619 17.666L16.5688 8.66026L15.7734 8.20312L11.1699 16.1803Z",
    fill: "#34B689"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventGreen);
export default __webpack_public_path__ + "static/media/event-green.14a93ef731d4a606913385176922d07e.svg";
export { ForwardRef as ReactComponent };